import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ciwhgi8nfq: FaireBrandEntity = {
  token: "b_ciwhgi8nfq",
  type: "brand",
  name: "The Crystal Tabby",
  avatarUrl:
    "https://cdn.faire.com/fastly/36033d7bae75921d4d5277e7bddff9feb19d874e62b6c1bf2ccb2b41a7a86058.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e064373d05a034ef0b6566503357e8b6e0b19154feaa19d4ac0fe3d3b68d16bb.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/36033d7bae75921d4d5277e7bddff9feb19d874e62b6c1bf2ccb2b41a7a86058.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e064373d05a034ef0b6566503357e8b6e0b19154feaa19d4ac0fe3d3b68d16bb.jpeg",
  location: "azusa, CA, USA",
  minimumOrderDollars: 137,
  rating: 5,
  reviewCount: 209,
  isTopShop: true,
  isInsider: true,
  description:
    "Women-owned and operated, The Crystal Tabby brings over 30 years of combined experience in the wholesale industry of crystals and minerals. Named for our love for our feline friends, we foster cats in our warehouse, giving them a place of solace and healing while we find their forever homes. Working directly with rescues like Tiny Pride and Del Gato, we leverage our business for good.\n\nAt The Crystal Tabby, you will always find quality material at great prices. Our experts are here to help on Faire and via social media. We pride ourselves on top-grade customer service, so please reach out if you have any questions or concerns.\n\nLocated in Azusa, California, please stop by if you find yourself in SoCal! We are open IRL from Monday through Saturday. Our hours are 9am-4pm Monday-Fridays. Come for the crystals, stay to pet the foster cats! ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:21.455Z",
    importedBy: "entity-db-cli",
  },
};
